declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export const GA_MEASUREMENT_ID = "G-ZQ9H1RTNX6";

export const isGaEnabled = (): boolean => {
  return (
    typeof window !== "undefined" &&
    typeof window.gtag === "function"
  );
};
export const pageview = (url: string): void => {
  if (!isGaEnabled()) return;

  window.gtag("event", "page_view", {
    page_path: url,
  });
};

interface UserProperties {
  player_id?: string;
  gender?: string;
  age_group?: string;
}

export const setUserProperties = (props: UserProperties): void => {
  if (!isGaEnabled()) return;

  const config: Record<string, unknown> = {
    user_properties: {
      gender: props.gender || "unknown",
      age_group: props.age_group || "unknown",
    },
  };

  if (props.player_id) {
    config.user_id = props.player_id;
  }

  window.gtag("set", config);
};

export const event = (
  action: string,
  params?: Record<string, unknown>
): void => {
  if (!isGaEnabled()) return;

  window.gtag("event", action, params);
};
